import { routerHelpers } from '@approvalmax/utils';
import { useSetAtom } from 'jotai';
import { selectors } from 'modules/common';
import { State } from 'modules/data';
import { integrationActions } from 'modules/integration';
import { helpers as pageHelpers } from 'modules/page';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { routingService } from 'services/routing';
import { useCreateRequest } from 'shared/data/webApp/v1';
import { hasChangesState } from 'shared/states';
import { getPath, Path } from 'urlBuilder';

import { isModifiedRequestState } from '../states';

const useCreateRequestPageData = () => {
    const dispatch = useDispatch();
    const params = useParams<{ companyId: string }>();
    const search = useLocation().search;
    const { mutate: createRequest } = useCreateRequest();
    const initialWorkflowId = routerHelpers.getParamAsString(search, 'workflowId', '');
    const workflowId = initialWorkflowId?.toLocaleLowerCase() || '';
    const template = useSelector((state: State) => selectors.template.findTemplateById(state, workflowId || ''));
    const company = useSelector((state: State) => selectors.company.findCompanyById(state, template?.companyId || ''));
    const integrationCode = template?.integrationCode;
    const needToRedirect = !template || !company;
    const cantDoRequests = integrationCode && !company?.flags.hasActiveIntegration;
    const setisModifiedRequest = useSetAtom(isModifiedRequestState);
    const setHasChanges = useSetAtom(hasChangesState);

    useEffect(() => {
        if (needToRedirect) {
            pageHelpers.redirectAndNotify();
        } else if (company?.id && cantDoRequests) {
            dispatch(integrationActions.showIntegrationErrorPopup(company.id));

            routingService.pushToDefaultPath();
        }
    }, [cantDoRequests, company?.id, dispatch, needToRedirect]);

    useEffect(() => {
        const loadNewRequest = async () => {
            createRequest(
                {
                    body: {
                        templateId: workflowId,
                        companyId: params.companyId,
                    },
                },
                {
                    onSuccess: (response) => {
                        setisModifiedRequest(false);
                        setHasChanges(false);

                        routingService.replace(getPath(Path.editRequest, response.requestId, params.companyId));
                    },
                    onError: () => {
                        routingService.pushToDefaultPath();
                    },
                }
            );
        };

        loadNewRequest();
    }, [createRequest, params.companyId, setHasChanges, setisModifiedRequest, workflowId]);
};

export default useCreateRequestPageData;
